import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actionTypes from '../constantes/actionTypes';
import { trackPlausibleEvent } from '../services/analytics';
import { CliniqueState, StepView } from '../type';
import ShadematchLoadingOverlay from './LoadingOverlay';
import { preloadShadematchResults } from './results';

const ShadematchAnalyse = () => {
	const { imageUser, wristImageUser, market } = useSelector((state: CliniqueState) => state.session);
	const [isComplete, setComplete] = useState(false);
	const dispatch = useDispatch();

	useEffect(() => {
		let isMounted = true;

		if (!imageUser || !wristImageUser) {
			return;
		}

		preloadShadematchResults(imageUser, wristImageUser, market).finally(() => {
			if (isMounted) {
				setComplete(true);
			}
		});

		return () => {
			isMounted = false;
		};
	}, [imageUser, market, wristImageUser]);

	useEffect(() => {
		if (!isComplete) {
			return;
		}

		trackPlausibleEvent('sm_loading_completed');
		dispatch({ type: actionTypes.SWITCH_STEP, value: StepView.shadematchResults });
	}, [dispatch, isComplete]);

	return <ShadematchLoadingOverlay />;
};

export default ShadematchAnalyse;
